import{__require as r}from"./a-callable.js";import{__require as e}from"./is-null-or-undefined.js";var i,n;function u(){if(n)return i;n=1;var u=r(),a=e();return i=function(r,e){var i=r[e];return a(i)?void 0:u(i)}}export{u as __require};
//# sourceMappingURL=get-method.js.map
